import { render } from "./dataLoder.vue?vue&type=template&id=e97043f0"
import script from "./dataLoder.vue?vue&type=script&lang=js"
export * from "./dataLoder.vue?vue&type=script&lang=js"

import "./dataLoder.vue?vue&type=style&index=0&id=e97043f0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__